// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useMemo} from 'react';
import {Link, useHistory} from 'react-router-dom';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Modal} from '../../../../hola/pub/lib/modal';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import Svg_thank_you from '../../img/thank_you_oculus.svg';
import Hand_truck_icon from '../../img/hand_truck.svg';
import Wrong_card_icon from '../../img/wrong_card.svg';
import Toolip_log_icon from '../../img/toolip_log.svg';
import Hand_truck_narrow_icon from '../../img/hand_truck_narrow.svg';
import Svg_woops from '../../img/woops_oculus.svg';
import {www_hola} from 'hola_opt';
import {Button} from '../shared/button';
import {get_payment_extra_url} from '../../../../oculus/pub/ui/dashboard/utils';
import {use_screen} from '../../../../hola/pub/lib/screen_util';

import styles from './notification_modals.module.less';

export const Notification_modals = ()=>{
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const {qs, set_qs} = use_qs_with_set();
    const {notification, plan_id = 'oculusv1_smart_resi_sm',
        zone_id, group_id, type, email, extra_limit, price} = qs || {};
    const is_toolip = www_hola.site == 'toolip';
    const {screen} = use_screen();
    const is_mobile = screen == 'xs';
    const close_notification = ()=>{
        set_qs({notification: undefined, plan_id: undefined,
            zone_id: undefined, type: undefined, extra_limit: undefined,
            price: undefined, email: undefined, group_id: undefined,
        });
    };
    const toolip_img_extra_limit_success = is_mobile ?
        <Hand_truck_narrow_icon/> : <Hand_truck_icon/>;
    const img_extra_limit_fail = is_toolip ? <Wrong_card_icon/> :
        <Svg_woops/>;
    const extra_limit_fail_title = is_toolip ?
        <p className={cn(styles.title_paragraph, theme.color_n700)}>
          Woops! Looks like there was an error to process your payment.
        </p> :
        <p className={cn(styles.title_paragraph,
          theme.color_n700)}>We couldn't process your payment.</p>;
    const modals = useMemo(()=>{
        return {
            extra_limit_success: {
                img: is_toolip ? toolip_img_extra_limit_success :
                  <Svg_thank_you/>,
                title: <p className={cn(
                  theme.color_n700,
                  styles.title_paragraph)}>Thank you for your purchase!</p>,
                text: <p className={cn(styles.text_paragraph)}>
                  Your invoice has been sent to the email address you've
                  provided ({email})
                  <br/><br/>If you don't use all of it, the rest will be
                  transferred to the renewed plan.
                </p>,
                buttons: <div className={cn(
                  {
                    [styles.toolip_btn]: is_toolip
                  }
                )}>
                  <Button
                    size={is_toolip ? 's': 'm'}
                    caption={'Got it'}
                    on_click={close_notification}
                    fit={!is_toolip}
                    inherit_width={is_toolip}
                  />
                </div>,
                footer: <div className={styles.extra_limit_success_footer}>
                  {is_toolip && <p className={cn(theme.p12, theme.reg)}>
                    Didn't get the email?
                    <a className={theme.med}
                      href="https://support.oculusproxies.com/hc/en-us">Resend
                    </a></p>}
                  <p className={cn(styles.footer_paragraph)}>
                    Need our help with anything? <a className={theme.med}
                    href="https://support.oculusproxies.com/hc/en-us">Contact
                    support</a>
                  </p>
                </div>,
            },
            extra_limit_fail: {
                extra_logo: is_toolip ? <Toolip_log_icon/> : undefined,
                img: img_extra_limit_fail,
                title: extra_limit_fail_title,
                text: <p className={cn(styles.text_paragraph)}>
                  Please update your payment details to avoid losing access
                  to your IPs permanently.
                </p>,
                buttons: <>
                  <Button caption={'Update payment details'} on_click={()=>{
                    const redir_url = get_payment_extra_url({zone_id, group_id,
                      extra_limit, price});
                    history.push(redir_url);
                  }}/>
                </>,
                footer: <p className={styles.footer_paragraph}>
                  {is_toolip ? <>
                    Need Help? <a className={theme.med}
                      href="https://support.oculusproxies.com/hc/en-us">Contact
                      support</a>
                  </> : <>
                    Need our help with anything? <a className={theme.med}
                      href="https://support.oculusproxies.com/hc/en-us">Contact
                      support</a>
                  </>}
                </p>,
            },
            auto_renew_success: {
                img: <Svg_thank_you/>,
                title: <p className={cn(theme.p20, theme.bold,
                  theme.color_n700)}>Auto-Renewal Enabled!</p>,
                text: <p className={cn(theme.p16, theme.med)}>
                  Your auto-renewal is now active! Your plan will automatically
                  renew at the end of each billing cycle to ensure
                  uninterrupted access to your IPs.
                </p>,
                buttons: <>
                  <Button caption={'Got it'} on_click={close_notification}/>
                </>,
                footer: <p className={theme.p14}>
                  You can manage or disable this setting anytime in
                  your <Link to="/dashboard/page/account"
                  className={theme.med}>account</Link>
                </p>,
            },
            auto_renew_fail: {
                img: <Svg_woops/>,
                title: <p className={cn(theme.p20, theme.bold,
                  theme.color_n700)}>
                  We couldn't renew your plan.
                </p>,
                text: <p className={cn(theme.p16, theme.med)}>
                  Please update your payment details to avoid losing access
                  to your IPs permanently.
                </p>,
                buttons: <>
                  <Button caption={'Update payment details'} on_click={()=>{
                    const redir_url = `/pricing/checkout?plan_id=${plan_id}`
                      +`&zone_id=${zone_id}`;
                    history.push(redir_url);
                  }}/>
                </>,
                footer: <p className={theme.p14}>
                  Need our help with anything? <a className={theme.med}
                  href="https://support.oculusproxies.com/hc/en-us">Contact
                  support</a>
                </p>,
            },
            no_matched_plans: {
                img: <Svg_woops/>,
                title: <p className={cn(theme.p20, theme.bold,
                  theme.color_n700)}>
                  Plan Renewal Unavailable
                </p>,
                text: <p className={cn(theme.p16, theme.med)}>
                  Unfortunately, we are unable to renew your current plan. To
                  continue using our service, please select and purchase a
                  new plan that suits your needs.
                </p>,
                buttons: <>
                  <Button caption={'Select plan'} on_click={()=>{
                    history.push(`/pricing/${type}`);
                  }}/>
                </>,
                footer: <p className={theme.p14}>
                  Need our help with anything? <a className={theme.med}
                  href="https://support.oculusproxies.com/hc/en-us">Contact
                  support</a>
                </p>,
            },
        };
    }, [qs]);
    const modal_width = is_toolip &&
        notification == 'extra_limit_fail' ? 335 : 480;
    return <>
      {Object.keys(modals).map(k=>{
        const m = modals[k];
        return <Modal key={k} lighter_close_btn={true}
          is_open={notification==k} width={modal_width}
          on_close={close_notification}
          on_overlay_click={ev=>{ ev.stopPropagation(); }}
          paddingless={true}>
          <div className={cn(styles.notification_modal, styles[notification], {
            [styles.notification_modal_toolip]: is_toolip,
          })}>
            {m?.extra_logo && <div className={styles.extra_logo}>
              {m.extra_logo}
            </div>}
            <div className={cn(styles.img)}>{m.img}</div>
            <div className={cn(styles.title)}>{m.title}</div>
            <div className={cn(styles.text)}>{m.text}</div>
            <div className={cn(styles.buttons)}>{m.buttons}</div>
            <div className={styles.footer}>
              {m.footer}</div>
          </div>
        </Modal>;
      })}
    </>;
};
